/**
 * Tenant Theme Configuration
 * Maps tenantId to a named palette from palettes.ts
 *
 * Note: Tertiary, Accent, and Neutral palettes remain same across all tenants
 */

import { DEFAULT_PALETTE, PALETTE_VIOLLET } from "./palettes";
import type { ITenantThemeConfig } from "./palettes";

export type { IColorPalette, ITenantThemeConfig } from "./palettes";
export { DEFAULT_PALETTE };

/**
 * Tenant-specific palette mapping
 * Add new tenants here by assigning a named palette
 */

// 606ed6954bbb886956db587b
// 64479969544bca001273b984
// "60545361083c2e000e909913" //musk
// "647a62e867f06c0013d938cf" //batman

const tenants = {
  BATMAN: "647a62e867f06c0013d938cf",
  MUSK: "60545361083c2e000e909913",
  PICASSO: "604c3df716a16d000e49297a",
  YES_MADAM: "698ee117f4185800de881194"
};
const TENANT_PALETTE_MAP: Record<string, ITenantThemeConfig> = {
  [tenants.BATMAN]: PALETTE_VIOLLET,
  [tenants.YES_MADAM]: PALETTE_VIOLLET,
  [tenants.PICASSO]: PALETTE_VIOLLET
};

/**
 * Get theme palette for a specific tenant
 * Returns custom palette if exists, otherwise returns default
 */
export const getTenantPalette = (tenantId: string | undefined): ITenantThemeConfig => {
  if (!tenantId) return DEFAULT_PALETTE;
  return TENANT_PALETTE_MAP[tenantId] || DEFAULT_PALETTE;
};
